export const INJECT_SIMPLE_FLOW_EDITOR = 'uicore:simpleFlowEditor';
export const INJECT_SIMPLE_FLOW_STEP_LIST = 'uicore:simpleFlowStepList';
export const INJECT_SIMPLE_FLOW_STEP_EDITOR = 'uicore:simpleFlowStepEditor';
//# sourceMappingURL=consts.js.map
